import { CircularProgress, Box, Backdrop, Portal } from "@mui/material";

const PageLoadingOverlay = ({ text = "Loading..." }: { text?: string }) => {
  return (
    <Portal>
      <Backdrop
        open
        sx={{
          position: "fixed",
          inset: 0,
          bgcolor: "rgba(0,0,0,0.5)",
          color: "#fff",
          zIndex: 999999,
          pointerEvents: "all",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress color="inherit" />
          {text && (
            <Box sx={{ mt: 2, fontSize: 16, textAlign: "center" }}>{text}</Box>
          )}
        </Box>
      </Backdrop>
    </Portal>
  );
};

export default PageLoadingOverlay;
